module.exports = __webpack_public_path__ + "img/scholar.8c06d12e.png";